module.exports = __webpack_public_path__ + "assets/img/3baoguo.410e8174.png";